import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-568fdf20"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "subtitle" }, "重置用户密码", -1));
const _hoisted_2 = { class: "name" };
import ChangePassword from "@/components/ChangePassword/index.vue";
import CloudTips from "@/components/CloudTips/index.vue";
import { useCounterStore } from "@/store/user";
// import { useLogin } from "./hooks";
export default /*#__PURE__*/ _defineComponent({
    name: 'ResetPassword',
    emits: ["success"],
    setup(__props, { emit }) {
        // const { changeState } = useLogin();
        const userStore = useCounterStore();
        const userInfo = userStore.userInfo;
        const userName = userInfo.user_name;
        // const bindMFA: string = userInfo.need_bind_mfa;
        const tipsText = "由于安全及管理需要，您必须重置您的登录密码之后，才可以访问";
        const success = () => {
            emit("success");
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, "用户名：" + _toDisplayString(_unref(userName)), 1),
                _createVNode(CloudTips, {
                    class: "neck-box",
                    text: tipsText
                }),
                _createVNode(ChangePassword, { onSuccess: success })
            ]));
        };
    }
});
